import { render, staticRenderFns } from "./NotifyMe.vue?vue&type=template&id=02e67df2&scoped=true"
import script from "./NotifyMe.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotifyMe.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotifyMe.vue?vue&type=style&index=0&id=02e67df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e67df2",
  null
  
)

export default component.exports